window.onload = function() {
    let data = {
      "store_id": 2,
      "account": email
    }
    /*$.ajax({
	    type: "POST",
      url: url_guide_fetch,
      dataType : 'json',
      data: JSON.stringify(data), // serializes the form's elements.
      contentType:'application/json',
      success:function (res){
        if (res.data == null || res.data.frequency == 0) {
        	nextStep()
        }
      },
      error: function(err){
           jQuery(".userInfo-tipsInfo").prepend("<div class='ui error message'>"+err.msg+"</div>");
				 currBTN.attr('disabled', false);
                 currBTN.html('<span>Submit</span>');
      }
    })*/
      
    //  导航
    let guideData = [{
      step: 1,
      ele: '#profile-guide-get-points',
      content: 'You can click the button to complete your information, and you will earn 10 points after completing this.'
     },
     {
      step: 2,
      ele: '#shareFacebook',
      content: 'You can share the code to your friends, and if he/she creates an account on VicTsing site through the link you shared, you will get 5 points for each signup.'
     },
     {
      step: 3,
      ele: '#profile-guide-join',
      content: 'You can join our member group on Facebook. We will have beneficial activities there. For example, we will invite people to test our new release in the group.'
     },
     {
      step: 4,
      ele: '#profile-guide-points',
      content: 'You can check you points, and go to the points store to exchange products or Amazon gift cards.'
     },
     {
      step: 5,
      ele: '#submitOrder',
      content: 'If you have purchased VicTsing products on Amazon, just enter your order number here to get the member points. Note: please select the proper Amazon site.'
     },
     {
      step: 6,
      ele: '#submitUrl',
      content: 'If you shared a photo of VicTsing product on social media like Facebook and Twitter. You can submit the post or tweet link here to earn scores. Note: The scores are used to upgrade your VIP level.'
     }
    ]


    let step = 0 // 当前是哪一元素
    let scrollTop = 0 // 滚动距离

    // NEXT TOUCH EVENT
    function nextStep() {
      step++
      $('.guide-body-container').text(guideData[step - 1].content)
      for (let i = 0; i < guideData.length; i++) {
        if (guideData[i].step == step) {
          $(guideData[i].ele).css({
            "z-index": 1052,
            'position': 'relative'
          })
        } else {
          $(guideData[i].ele).css("z-index", 1)
        }
      }
      let eleWidth = $(guideData[step - 1].ele).width()
      let eleHeight = $(guideData[step - 1].ele).height()
      let offset = $(guideData[step - 1].ele).offset()
      let windowWidth = $(window).width()
      let windowHeight = $(window).height()
      
      if(step == 2) {
        $('.share-facebook').css({'backgroundImage': 'url(//cdn.shopify.com/s/files/1/1769/5297/t/28/assets/facebookChecked.png?41791)'})
        $('.share-twitter').css({'backgroundImage': 'url(//cdn.shopify.com/s/files/1/1769/5297/t/28/assets/twitterChecked.png?41791)', 'z-index': 1052,'position': 'relative'})
      } else {
      	$('.share-facebook').css({'backgroundImage': 'url(//cdn.shopify.com/s/files/1/1769/5297/t/28/assets/profile-facebook.png?41791)'})
        $('.share-twitter').css({'backgroundImage': 'url(//cdn.shopify.com/s/files/1/1769/5297/t/28/assets/profile-twitter.png?41791)', 'z-index': 1})
      }
      $('#modal-footer').css({
        "justify-content": "center",
        "align-items": "center"
      })
      $('.guide-current').text(step)
      $('#modal-header').hide()
      $('.triangle-left').hide()
      $('#modal-footer').show()

      // 判断offset
      if ($('body').height() - offset.top < $('#modal-guide').height()) {
        $('body').css({
          'margin-bottom': windowHeight - ($('body').height() - offset.top)
        })
      }
     
      scrollTop = $(window).scrollTop()
      // 判断是否为手机屏幕
      if (windowWidth < 768) {
        // 判断当前元素距离底部距离
        $('#modal-guide').css({
          'margin-top': eleHeight + 58 + 72,
          'margin-left': (windowWidth - 340) / 2
        })
        $('.triangle-top').css({
          'margin-left': offset.left + 8
        })
         // 滚动
        $('html, body').animate({
          scrollTop: offset.top - 72 - 40
        }, 300)
        // 判断右侧大小是否小于380
      } else {
        if (windowWidth - offset.left - eleWidth > 340) {
          	$('#modal-header').show()
            $('.triangle-left').show()
            $('.triangle-top').hide()
            $('#modal-footer').hide()
            let width = 0
            if (step === 2) {
            	width = offset.left + eleWidth + 36 + 32
            }else {
                width =  offset.left + eleWidth + 42
            }
        	$('#modal-guide').css({
              'margin-top': eleHeight + 72 ,
              'margin-left': width
            })
            // 滚动
            $('html, body').animate({
              scrollTop: offset.top - 72 - 58 - 34
            }, 300)
        } else {
          $('#modal-header').hide()
            $('.triangle-left').hide()
            $('.triangle-top').show()
            $('#modal-footer').show()
          $('#modal-guide').css({
            'margin-top': scrollTop == 0 ? offset.top + eleHeight + 48 : eleHeight + 58 + 72,
            'margin-left': offset.left + eleWidth - $('.modal-content').width()
          })
          $('.triangle-top').css({
            'margin-left': $('.modal-content').width() - eleWidth / 2 - 5
          })
          // 滚动
          $('html, body').animate({
            scrollTop: offset.top - 72 - 40
          }, 300)
        }
      }
      if ($('.modal-content').width() + offset.top + eleHeight - windowHeight > 0) {
        $('body').css({
          'margin-bootm': $('.modal-content').width() + offset.top + eleHeight - windowHeight
        })
      }
      $('#guide').modal('show')
      location.href = '#modal-guide'
    }

    // CANCLE BUTTON
    $('.modal-guide-cancel').click(function () {
      $('#guide').modal('hide')
      $('html, body').animate({
        scrollTop: 0
      }, 1000)
      if (step<= 2){
      	guidePass()
      }
    })

    // NEXT | DONE
    $('#guide-button').click(function () {
      
      if (step !== 6) {
        if (step == 5) $(this).text('DONE')
        nextStep()
      } else {
        $('body').css({
          'margin-bottom': 0
        })
        $('html, body').animate({
          scrollTop: 0
        }, 1000)
        $('#guide').modal('hide')
       
      }
      if (step === 2) {
        guidePass()
      }
    })

}


function guidePass () {
	let data = {
      "store_id": 2,
      "account": email
    }
    $.ajax({
	  type: "POST",
      url: url_guide_update,
      dataType : 'json',
      data: JSON.stringify(data), // serializes the form's elements.
      contentType:'application/json',
      success:function (res){
      },
      error: function(err){
           console.log(err)
      }
    })
      

}